<template>
  <div>324234324324324324324</div>

</template>
<script>
import api from '@/modules/api.js'
export default {
  name: 'test1',
  data () {
    return {

      }
  },
  components: {

  },
  methods: {

  },
  mounted () {
    this.$nextTick(function () {
      alert()
    })
    // this.$app.NaviInit.init('入司考试')
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/test/test1.vue